import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';

const AUDIT_TABS = [
  { key: '/audit', labelKey: 'audit.list_title' },
  { key: '/audit/configs', labelKey: 'audit.config_list_title' },
];

export default function AuditNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const activeKey = AUDIT_TABS.find(
    (tab) => tab.key !== '/audit'
      ? location.pathname.startsWith(tab.key)
      : location.pathname === '/audit' || location.pathname.startsWith('/audit/logs')
  )?.key ?? '/audit';

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) => navigate(key)}
      items={AUDIT_TABS.map((tab) => ({
        key: tab.key,
        label: t(tab.labelKey),
      }))}
      style={{ marginBottom: 16 }}
    />
  );
}
